import Menarasyariah1 from "./menarasyariah (1).webp";
import Menarasyariah2 from "./menarasyariah (2).webp";
import Menarasyariah3 from "./menarasyariah (3).webp";
import Menarasyariah4 from "./menarasyariah (4).webp";
import Menarasyariah5 from "./menarasyariah (5).webp";

const menarasyariah = [
  Menarasyariah1,
  Menarasyariah2,
  Menarasyariah3,
  Menarasyariah4,
  Menarasyariah5,
];

export default menarasyariah;
